import { FormType } from "@simplyk/common";

import {
  FreeFormsDonationDesktop,
  FreeFormsDonationMobile,
  FreeFormsTicketingDesktop,
  FreeFormsTicketingMobile,
} from "../../../../common/constants/params";
import { useFormV2Context } from "../contexts/FormV2Context";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";

export const useUtmForm = (): string => {
  const { type } = useFormV2Context();
  const { isPhoneScreen } = useMediaQuery();

  const utmMap = {
    [FormType.DonationForm]: {
      mobile: FreeFormsDonationMobile,
      desktop: FreeFormsDonationDesktop,
    },
    [FormType.Ticketing]: {
      mobile: FreeFormsTicketingMobile,
      desktop: FreeFormsTicketingDesktop,
    },
  };

  return utmMap[type][isPhoneScreen ? "mobile" : "desktop"];
};
